(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diary-bundle-upgrade"]) return;
  try {
    
  if (!customElements.get('diary-bundle-upgrade')) {
    customElements.define('diary-bundle-upgrade', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.diaryVariants = JSON.parse(this.dataset.diaryVariants);
        this.bundleVariants = JSON.parse(this.dataset.bundleVariants);
        this.offered = false;
        this.openCartAfterClose = false;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.previousUpcartContinue = window.upcartShouldAddToCartContinue;
        this.upcartContinue = event => {
          const form = event.target?.closest('form[is="product-form"]');
          if (this.isEligibleForm(form)) return false;
          return typeof this.previousUpcartContinue === 'function' ? this.previousUpcartContinue(event) : true;
        };
        window.upcartShouldAddToCartContinue = this.upcartContinue;

        document.addEventListener('variant:add', event => this.onVariantAdded(event), { capture: true, signal });
        window.addEventListener('aftersell-upcart:public-events:cart-opened', () => {
          if (this.dialog.open) window.upcartCloseCart?.();
        }, { signal });
        this.querySelectorAll('[data-decline]').forEach(button => button.addEventListener('click', () => { if (!this.updating) this.dialog.close(); }, { signal }));
        this.querySelector('[data-accept]').addEventListener('click', () => this.accept(), { signal });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog && !this.updating) this.dialog.close(); }, { signal });
        this.dialog.addEventListener('cancel', event => { if (this.updating) event.preventDefault(); }, { signal });
        this.dialog.addEventListener('close', () => {
          if (this.openCartAfterClose) this.openCart();
          this.openCartAfterClose = false;
        }, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (window.upcartShouldAddToCartContinue === this.upcartContinue) {
          window.upcartShouldAddToCartContinue = this.previousUpcartContinue || (() => true);
        }
      }

      money(cents) {
        return new Intl.NumberFormat(Shopify.locale || document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: Shopify.currency.active
        }).format(cents / 100);
      }

      isEligibleForm(form) {
        if (this.offered || !form?.closest('.shopify-section--main-product')) return false;
        if (!form.getAttribute('id')?.startsWith('product-form-')) return false;
        if (window.themeVariables?.settings?.cartType !== 'drawer') return false;
        const formData = new FormData(form);
        if (Number(formData.get('quantity') || 1) !== 1 || formData.get('selling_plan')) return false;
        const diaryVariant = this.diaryVariants.find(variant => Number(variant.id) === Number(formData.get('id')));
        return Boolean(diaryVariant && this.bundleVariants.some(variant =>
          variant.available && variant.option1?.toLowerCase() === diaryVariant.option1?.toLowerCase()
        ));
      }

      onVariantAdded(event) {
        if (this.offered || window.themeVariables?.settings?.cartType !== 'drawer') return;
        if (event.target?.tagName !== 'FORM' || !this.isEligibleForm(event.target)) return;
        const items = event.detail?.items || [];
        const added = items.find(item => Number(item.product_id) === Number(this.dataset.diaryId));
        if (!added || added.selling_plan_allocation) return;
        if (event.detail.cart?.items?.some(item => Number(item.product_id) === Number(this.dataset.bundleId))) return;

        const diaryVariant = this.diaryVariants.find(variant => Number(variant.id) === Number(added.variant_id || added.id));
        const bundleVariant = this.bundleVariants.find(variant => variant.available && variant.option1?.toLowerCase() === diaryVariant?.option1?.toLowerCase());
        const diaryLine = event.detail.cart?.items?.find(item => item.key === added.key && !item.selling_plan_allocation)
          || event.detail.cart?.items?.find(item => Number(item.variant_id) === Number(added.variant_id || added.id) && !item.selling_plan_allocation);
        if (!bundleVariant || !diaryLine || bundleVariant.price <= added.price) return;

        event.detail.blockCartDrawerOpening = true;
        this.offered = true;
        this.diaryLineKey = diaryLine.key;
        this.bundleVariantId = bundleVariant.id;
        this.querySelector('[data-colour]').textContent = `(${diaryVariant.option1})`;
        this.querySelector('[data-diary-price]').textContent = this.money(added.price);
        this.querySelector('[data-bundle-price]').textContent = this.money(bundleVariant.price);
        this.querySelector('[data-difference]').textContent = this.money(bundleVariant.price - added.price);
        const comparePrice = this.querySelector('[data-compare-price]');
        const saving = this.querySelector('[data-saving]');
        if (bundleVariant.compare_at_price > bundleVariant.price) {
          comparePrice.textContent = this.money(bundleVariant.compare_at_price);
          comparePrice.hidden = false;
          this.querySelector('[data-saving-amount]').textContent = `Save ${this.money(bundleVariant.compare_at_price - bundleVariant.price)}`;
          saving.hidden = false;
        }
        this.openCartAfterClose = true;
        window.upcartCloseCart?.();
        this.dialog.showModal();
      }

      async readCart() {
        const response = await fetch(`${Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Your cart could not be checked.');
        return response.json();
      }

      async finishUpgrade() {
        this.openCartAfterClose = false;
        this.dialog.close();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        try { await this.refreshDrawer(); } catch (_) {}
        this.openCart();
      }

      async accept() {
        if (this.updating) return;
        if (this.recoveryRequired) {
          this.openCartAfterClose = false;
          this.dialog.close();
          this.openCart();
          return;
        }
        const button = this.querySelector('[data-accept]');
        const status = this.querySelector('[data-status]');
        const originalLabel = button.textContent;
        this.updating = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[data-decline]').forEach(control => { control.disabled = true; });
        status.textContent = 'Updating your cart…';
        const root = Shopify.routes.root;
        const token = crypto.randomUUID();
        let originalQuantity;
        let addAttempted = false;
        let removalAttempted = false;
        let committed = false;
        try {
          const initialCart = await this.readCart();
          const originalDiary = initialCart.items.find(item => item.key === this.diaryLineKey);
          if (!originalDiary || originalDiary.quantity < 1) throw new Error('Your cart changed. Please check your cart before upgrading.');
          originalQuantity = originalDiary.quantity;
          addAttempted = true;
          const added = await fetch(`${root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: this.bundleVariantId, quantity: 1, properties: { _diary_upgrade: token } })
          });
          if (!added.ok) throw new Error((await added.json()).description || 'The bundle could not be added.');

          const currentCart = await this.readCart();
          const diaryLine = currentCart.items.find(item => item.key === this.diaryLineKey);
          if (!diaryLine || diaryLine.quantity !== originalQuantity) throw new Error('Your cart changed before the Diary could be replaced.');
          removalAttempted = true;
          const changed = await fetch(`${root}cart/change.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: diaryLine.key, quantity: originalQuantity - 1 })
          });
          if (!changed.ok) throw new Error('The Diary could not be replaced.');
          committed = true;
        } catch (error) {
          if (!addAttempted) {
            status.textContent = `${error.message} You can try again.`;
          } else {
            try {
              let cart = await this.readCart();
              const bundleLine = cart.items.find(item => item.properties?._diary_upgrade === token);
              const diaryQuantity = cart.items.find(item => item.key === this.diaryLineKey)?.quantity || 0;
              if (bundleLine && removalAttempted && diaryQuantity === originalQuantity - 1) {
                committed = true;
              } else if (diaryQuantity === originalQuantity) {
                if (bundleLine) {
                  const rollback = await fetch(`${root}cart/change.js`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ id: bundleLine.key, quantity: 0 })
                  });
                  if (!rollback.ok) throw new Error('The bundle could not be removed.');
                  cart = await this.readCart();
                  if (cart.items.some(item => item.properties?._diary_upgrade === token)) throw new Error('The bundle is still in the cart.');
                }
                status.textContent = 'The upgrade could not be completed. Your Diary is still in the cart. Please try again.';
              } else {
                throw new Error('Your cart changed during the upgrade.');
              }
            } catch (_) {
              this.recoveryRequired = true;
              button.textContent = 'Review cart';
              status.textContent = 'We could not confirm the upgrade. Please review your cart before continuing; it may contain both the Diary and bundle.';
            }
          }
        } finally {
          this.updating = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (!this.recoveryRequired) button.textContent = originalLabel;
          this.querySelectorAll('[data-decline]').forEach(control => { control.disabled = false; });
        }
        if (committed) await this.finishUpgrade();
      }

      async refreshDrawer() {
        if (typeof window.upcartRefreshCart === 'function') {
          await window.upcartRefreshCart();
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        const sectionId = drawer?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        if (!drawer || !sectionId) return;
        try {
          const response = await fetch(`${Shopify.routes.root}?section_id=${encodeURIComponent(sectionId)}`);
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const updated = html.querySelector('cart-drawer');
          if (updated) drawer.replaceChildren(...updated.children);
        } catch (_) { /* cart:refresh still updates the drawer. */ }
      }

      async openCart() {
        if (typeof window.upcartOpenCart === 'function') {
          try { await window.upcartRefreshCart?.(); } catch (_) { /* The drawer can still be opened. */ }
          window.upcartOpenCart();
          return;
        }
        document.querySelector('cart-drawer')?.show();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diary-inside-pages"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diary-inside-pages')) {
    customElements.define('diary-inside-pages', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.toggle = this.querySelector('[data-fill-toggle]');

        this.toggle?.addEventListener('click', () => {
          const filled = !this.classList.contains('is-filled');
          this.classList.toggle('is-filled', filled);
          this.toggle.setAttribute('aria-checked', String(filled));
        });

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));

        this.steps = [...this.querySelectorAll('[data-step]')];
        this.steps.forEach((step, index) => step.addEventListener('click', () => this.scrollToIndex(index)));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateSteps());
        }, { passive: true });
      }

      get currentIndex() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth) || 0;
      }

      go(direction) {
        const count = this.track.children.length;
        this.scrollToIndex((this.currentIndex + direction + count) % count);
      }

      scrollToIndex(index) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateSteps() {
        const current = this.currentIndex;
        this.querySelectorAll('[data-description]').forEach((description) => {
          description.classList.toggle('is-active', Number(description.dataset.description) === current);
        });
        this.steps.forEach((step, index) => {
          if (index === current) {
            step.setAttribute('aria-current', 'step');
          } else {
            step.removeAttribute('aria-current');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diary-video-hook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diary-hook-video')) {
    customElements.define('diary-hook-video', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          video.play().catch(() => { button.hidden = false; });
        }, options);
        video.addEventListener('play', () => {
          if (document.activeElement === button) video.focus();
          button.hidden = true;
        }, options);
        video.addEventListener('ended', () => { button.hidden = false; }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PLAYING = 'is-playing';

  const mediaOf = (el) => el.closest('[data-rv-video]');
  const videoOf = (el) => {
    const media = mediaOf(el);
    return media ? media.querySelector('video') : null;
  };

  const play = (media) => {
    const video = media.querySelector('video');
    if (!video) return;
    media.classList.add(PLAYING);
    // play() rejects when the browser blocks playback - swallow it rather
    // than throwing an unhandled rejection into the console.
    const started = video.play();
    if (started && typeof started.catch === 'function') {
      started.catch(() => media.classList.remove(PLAYING));
    }
  };

  const stop = (media) => {
    const video = media.querySelector('video');
    if (!video) return;
    media.classList.remove(PLAYING);
    video.pause();
    video.currentTime = 0;
    video.muted = true;
    const button = media.querySelector('[data-rv-sound]');
    if (button) button.setAttribute('aria-pressed', 'true');
  };

  // Hover to preview, on devices that actually have a pointer.
  const canHover = window.matchMedia('(hover: hover)').matches;

  if (canHover) {
    document.addEventListener('mouseover', (event) => {
      const media = event.target.closest && mediaOf(event.target);
      if (media && !media.contains(event.relatedTarget)) play(media);
    });

    document.addEventListener('mouseout', (event) => {
      const media = event.target.closest && mediaOf(event.target);
      if (media && !media.contains(event.relatedTarget)) stop(media);
    });
  }

  // Tap to play/pause - the only way touch users can reach these videos.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target.closest) return;

    const soundButton = target.closest('[data-rv-sound]');
    if (soundButton) {
      event.preventDefault();
      event.stopPropagation();
      const video = videoOf(soundButton);
      if (!video) return;
      video.muted = !video.muted;
      soundButton.setAttribute('aria-pressed', String(video.muted));
      if (video.paused) play(mediaOf(soundButton));
      return;
    }

    const media = mediaOf(target);
    if (!media) return;
    if (media.classList.contains(PLAYING)) {
      stop(media);
    } else {
      document.querySelectorAll('[data-rv-video].' + PLAYING).forEach(stop);
      play(media);
    }
  });

  // Stop anything still playing once it scrolls out of view.
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.target.classList.contains(PLAYING)) {
            stop(entry.target);
          }
        });
      },
      { threshold: 0 }
    );
    const observeAll = () =>
      document.querySelectorAll('[data-rv-video]').forEach((el) => observer.observe(el));
    observeAll();
    document.addEventListener('shopify:section:load', observeAll);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
